import troubles from "./bs_en_troubles";
export default [
  [
    {
      q: "為什麽搜尋不到車輛？",
      a:
        "1.請檢查車輛是否處於啟動狀態，並處於P檔；<br/>\
        2.請檢查手機藍牙功能是否處於已開啟狀態，或嘗試重啟手機藍牙功能。<br/>\
        （由於Android10系統BUG，Android10系統版本用戶需要開啟定位功能）<br/>\
      3.請檢查車輛是否正處於待綁定狀態。<br/>\
      為保證您的車輛安全，車輛進入待啟用狀態後，若2分鐘內無任何操作、被推行或駕駛，車輛將自動退出待啟用狀態，或導致無法搜索到車輛；<br/>\
      您可通過再次啟動車輛，在特定時間內通過APP搜索完成啟用操作。"
    },

    {
      q: "點擊連接搜尋到的車輛，但是提示連接失敗？",
      a:
        "1.請檢查車輛是否正處於待綁定狀態。<br/>\
        為保證您的車輛安全，車輛進入待綁定狀態後，若5分鐘內無任何操作、推行或駕駛，車輛將自動退出帶綁定狀態，導致車輛無法連接。<br/>\
        您可通過重啟車輛，在特定時間內通過APP搜索完成激活操作。<br/>\
        2.可能是由於您手機藍牙的信號不穩定，造成連接困難。您可以嘗試重新開關手機藍牙功能，再次嘗試連接車輛。"
    },
    {
      q: "搜尋到多輛車，如何確定需要啟用目標車輛？",
      a:
        "您可以通過對照車架號信息，來確定您要綁定的是哪輛車。車架號通常在您車輛座桶內充電口附近，或印有VIN的位置，如下圖所示：\
      <div style='text-align:center;padding-top:24px;'><img src='/static/img/q3.png' width='180px' alt=''></div>"
    },
    {
      q: "一直顯示“車輛網路啟用中…”，該怎麽辦？",
      a:
        "1.請檢查您的車輛網路是否正常。<br/>\
        您可通過車輛螢幕查看網絡狀態，若發現車輛網路狀態不好，建議您將車輛移至開闊的室外環境或網路良好的環境下。<br/>\
      2.請檢查您的手機網路是否正常。<br/>\
      可能由於您的手機網路異常或不穩定，導致啟用狀態未能及時同步。<br/>\
      3.檢查您APP的“通知權限”是否開啟。您可嘗試前往手機設置中心→通知→APP→打開通知權限；（用於手機系統版本差異，操作流程可能存在差異）<br/>\
      4.您可嘗試重啟App，或退出App登錄賬號並重新登錄來解決這個問題。"
    },
    {
      q: "啟用綁定後，就完成了與車輛的藍牙連接嗎？",
      a:
        "啟用綁定後，手機與車輛僅完成了BLE（低功耗藍牙）模組的連接，用於手機與車輛的基本通讯。<br/>\
        如需通過藍牙連接，使用音樂或電話等藍牙相關功能，請前往手機系統設定中，通過手機藍牙搜尋進行連接。"
    },
    {
      q: "如何解除綁定車輛？",
      a:
        "從APP側邊欄選擇要解綁的車輛，點擊刪除車輛，勾選刪除協議後點擊刪除即可成功解除綁定。"
    },

    {
      q: "APP解綁車輛後，車輛無法進入待啟用狀態？",
      a:
        "APP解綁後，車輛無法重新進入待綁定狀態，可能是因為當前車輛網路不佳導致的：<br/>\
      1.您可將車輛停放在環境開闊，網路較好的位置，並重啟車輛查看狀態；<br/>\
      2.檢查車輛智能服務是否到期，若智能服務已到期，請續費後，重啟車輛進行查看。<br/>\
      *部分車型可以進入車輛設置功能，找到「進入待綁定」模式，主動將車輛設置為待綁定狀態。"
    }
  ],
  [
    {
      q: "如何更換/解綁手機號？",
      a:
        "為保證您的帳戶安全，啟用車輛後務必需要綁定手機門號，因此啟用車輛的帳號不支援直接解綁，僅支持更換成其他手機門號。<br/>\
        如需更換，您可使用APP點擊設置，進入帳號安全中心，對帳號綁定進行管理，點擊手機號進行變更即可。"
    },

    {
      q: "一個帳號可以多個設備使用嗎？",
      a:
        "帳號登錄是不限制手機設備的，但是為了保護帳號安全及車輛安全，不支援一個帳號同時在多個手機設備上使用，否則可能會被自動退出。"
    },

    {
      q: "如何註銷帳號？",
      a:
        "APP支援帳號註銷，但您需要确保該帳號下已無綁定車輛，且無未完成或未支付的服務。<br/>\
        您可點擊設定→帳號安全→帳戶註銷，進行帳號的註銷。<br/>\
        註銷帳號是不可恢復的操作，請您謹慎操作。註銷成功後，您將無法登陸或使用THEMO帳號内的所有訊息。"
    },

    {
      q: "如何管理車輛的數據權限？",
      a:
        "我们非常重視您的隱私保護和個人資訊的保護。<br/>\
        您可以利用App但不限於查看車況，定位車輛，定位您所在的位置、車輛動態紀錄，以及遙控車輛，設置車輛等功能。<br/>\
        在秉着“最小化”原則的前提下，我们將直接或間接獲取您的車輛的定位及行駛軌跡資訊，並做加密處理。<br/>\
        您可以通過進入車輛管理介面，選擇“車輛數據與權限”功能進行權限的管理。相應功能停用後，可能導致部分功能無法正常使用。"
    }
  ],
  [
    {
      q: "騎行之前，需要做哪些準備？",
      a:
        "為保證您的騎行安全，請在騎行前做如下準備：<br/>\
      1.檢查車輛能否正常通電，燈光照明等狀態是否正常；<br/>\
      2.檢查前、後煞車能否正常⼯作；<br/>\
      3.檢查輪胎的氣壓是否正常；<br/>\
      4.檢查車把及前後輪是否固定，龍頭鎖是否已解鎖；<br/>\
      5.保證電池電量充⾜；<br/>\
      6.是否存在其他故障提示；<br/>\
      7.佩戴好頭盔及其他符合要求的護具。"
    },
    {
      q: "如何啟動車輛？",
      a:
        "您可以通過多種⽅式啟動車輛：<br/>\
        1.遙控鑰匙：(1) 點擊遙控器上的開鎖按鈕；(2) 攜帶遙控鑰匙，靠近⻋輛後，開機鍵（如電源鍵或ready鍵）會規律閃爍，長按可啟動車輛；<br/>\
        2.⼿機App：(1) 打開⼿機 App 點擊「一鍵啟動」來啟動車輛；(2) ⻋輛綁定⼿機，靠近⻋輛後，開機鍵（如電源鍵或ready鍵）會規律閃爍，長按可啟動車輛；<br/>\
        3.指紋解鎖：部分車型帶有指紋識別區，用戶⽆需隨身攜帶鑰匙或⼿機，使用指紋即可啟動車輛。"
    },
    {
      q: "為什麽車輛啟動後，擰轉把沒有動力？",
      a:
        "為了保護您的騎行安全，避免飛車等風險狀況發生，車輛通過傳感器對起步進行了安全限制。<br/>\
        您在騎行前，需要收起側撐或中撐，並坐在車輛上。<br/>\
        並按下右手把“READY”見鍵，此時“READY”指示燈亮起，車輛將進入待騎行狀態。此時，您可通過擰動轉把為車輛提供動力。<br/>\
        以上功能僅部分車型具備該功能，可以通過手機APP的車輛中心進行開關設置。"
    },

    {
      q: "結束騎行後，需要做哪些事情？",
      a:
        "到達目的地後，點按「READY」鍵取消 READY 模式，並放下側撐或中撐。<br/>\
        您可通過以下方式為車輛上鎖：<br/>\
        1.遙控器：點擊遙控器上的上鎖按鈕；<br/>\
        2.⼿機：打開⼿機 App，點擊「設防」為車輛上鎖；<br/>\
        3.⻋身：根據車輛說明書的引導，通過⻋輛把⼿上的物理按鍵進行設防。<br/>\
        車輛上鎖後，請將車輛龍頭轉至左轉向並檢查龍頭鎖是否鎖定。"
    }
  ],
  [
    {
      q: "什麽是電子側撐感應功能？",
      a:
        "為保證您的騎行安全，電子側撐感應功能用於檢測側撐支起或收起的狀態。當您準備騎行時，電子側撐感應功能將會提醒您收起側撐後開始騎行。<br/>\
        該功能可通過車機系統或者是App設置開啟或關閉，建議新手用戶保持該功能的開啟。 "
    },

    {
      q: "什麽是座墊重力檢測功能？",
      a:
        "為保證您的騎行安全，座墊重力檢測功能用於檢測車輛上是否已坐了人。當您準備騎行時，座墊重力檢測功能將會提醒您坐穩後開始騎行。<br/>\
        該功能可通過車機系統或者是App設置開啟或關閉，建議新手用戶保持該功能的開啟。"
    },
    {
      q: "什麽是轉向輔助功能？",
      a:
        "為保證您的騎行安全，轉向輔助功能可以在您轉向過程中，激活後方攝像頭，呈現車輛後方的路況信息，以彌補因視覺盲區所帶來的轉向風向。<br/>\
        （該功能僅部分車型支持）"
    },
    {
      q: "什麽是倒車輔助功能？",
      a:
        "為保證您的騎行安全，倒車輔助功能可以在您倒車過程中，激活後方攝像頭及後方超聲雷達，呈現車輛後方的障礙物及障礙物的距離，以彌補因視覺盲區所帶來的倒車風向。<br/>\
        （該功能僅部分車型支持）"
    }
  ],
  [
    {
      q: "如何連接手機藍牙？",
      a:
        "1.在車輛駐車狀態下，打開智能菜單選擇藍牙設置功能；<br/>\
      2.選擇“手機”並開啟藍牙功能，選擇連接手機；<br/>\
      3.打開手機，並打開藍牙頁面，以保證手機設備可以被搜索到；<br/>\
      4.通過車機選擇自己的手機設備並連接；<br/>\
      5.車機具有藍牙記憶功能，連接過的手機設備在下壹次接近車機時，會自動連接。（IOS設備在不關閉手機藍牙開關的情況下，支持記憶功能，Android設備不受手機藍牙開關影響）<br/>\
      6.若要斷開鏈接，選擇斷開相應的設備即可；<br/>\
      7.若搜到不到您的手機設備，請確認手機藍牙是否開啟，並確認手機是否處於藍牙頁面。若仍未搜索到，可嘗試關閉“藍牙開關”再重新打開。"
    },
    // {
    //   q: "如何连接蓝牙耳机或蓝牙头盔？",
    //   a:
    //     "（目前该功能仅支持R1 车型）<br/>\
    //   1.在车辆驻车状态下，打开智能菜单选择蓝牙设置功能；<br/>\
    //   2.选择“耳机/头盔”并开启蓝牙功能，选择您的设备名称并连接；<br/>\
    //   3.打开手机，并打开蓝牙页面，以保证手机设备可以被搜索到；<br/>\
    //   4.若要断开链接，选择断开相应的设备即可。"
    // },
    {
      q: "如何使用藍牙音樂功能？",
      a:
        "1.請確保車輛已經連接了您的手機和耳機/頭盔，若未連接耳機/頭盔，音樂將通過車載音響進行外放；<br/>\
      2.使用手機播放音樂後，無論是駐車模式還是行車模式，妳都可以通過車機選擇並播放您的音樂；<br/>\
      3.您可通過車機上的播放/暫停鍵執行播放和暫停指令，點擊OK鍵播放下壹曲，點按音量加減鍵放大或縮小音量。"
    }
    // {
    //   q: "如何使用蓝牙电话功能？",
    //   a:
    //     "（目前该功能仅支持R1 车型）<br/>\
    //   1.在车辆驻车状态下，打开智能菜单选择蓝牙电话功能；<br/>\
    //   2.请确保车辆已经连接了您的手机和耳机/头盔，需要您耳机/头盔的麦克风进行通话。<br/>\
    //   3.选择“同步通讯录”，将手机的最近联系人和通话记录同步到车机上；<br/>\
    //   4.我们为您提供了“最近联系人”“所有通话”“未接来电”三个选项，你可以在驻车状态下进行外呼。<br/>\
    //   最近联系人：车辆读取手机通讯录中最近有过通话的10个人；<br/>\
    //   所有通话：车辆显示最近3天的通话记录（最多20条）；<br/>\
    //   未接来电：车辆在所有通话中筛选出所有未接来电（最多20条）；<br/>\
    //   5.若有人向你呼入通话，你可通过按车机上的OK键接通，或使用“返回”键挂断。"
    // }
  ],
  [
    {
      q: "關於車輛定位的問題",
      a:
        "車輛是通過衛星的GPS信號獲得定位。車輛在室內或地庫等封閉區域時，將影響車輛定位的準確性。將車輛移至開闊的壞境，GPS定位功能將恢復。<br/>\
        車輛軌跡是車輛在規定時間內上報的定位點一次連線形成的車輛軌跡。由於定位偏移以及信號遮擋，會造成捕捉到錯誤的定位甚至丟失定位點的情況，導致軌跡異常或不準確的情況。<br/>\
        若長時間不能定位或大部分軌跡異常，請檢查車輛智能服務是否到期，若未到期，可聯繫售後檢查車輛的網路及GPS的情況。"
    },

    {
      q: "關於消息推送的問題",
      a:
        "您可以通過以下操作進行排查：<br/>\
      1.請您確認首頁右上角消息中心列表裏是否可以收到相應的推送消息，如車輛震動；<br/>\
      2.管理手機的通知設置：您可前往手機設置中心，選擇通知功能，選擇App，確認相應的功能已經開啟。<br/>\
      3.App內選擇車輛，選擇車輛防盜模式，查看相應的通知推送是否開啟。"
    },

    {
      q: "什麽是車輛的安防模式？",
      a:
        "為保證您的車輛安全，針對車輛的異常動向進行了消息推送提醒，包括車輛的震動、輪動、電池斷開、電池過放等。<br/>\
        您可以根據車輛的停放風險，選擇警戒模式或勿擾模式，進行安防的個性化設置。<br/>\
        當車輛發生異動，可通過查看車輛定位，查看車輛當前位置，確保車輛的安全。"
    },

    {
      q: "預計行駛里程計算不準確的問題",
      a:
        "車輛的預計行駛裏程，是根據用戶的駕駛習慣於耗電量的情況綜合統計而來的。影響預估裏程準確性有多種原因，例如載物的情況、道路情況以及環境溫度等，通常偏差值在20%之間屬於正常現象。<br/>\
        如果有明顯偏大或偏小的情況，通常不是電池出了問題，而是在數據統計端由於數據穩定性或數據錯誤導致的。若騎行數次後仍存在偏差大的問題，可聯系售後進行問題的排查。"
    },

    {
      q: "車輛遠程控制沒有反應怎麽辦？",
      a:
        "請您查看當前手機網絡是否正常，並查看app首頁右上角藍牙和網絡是否連接正常。若網絡或藍牙狀態任意壹個連接正常的情況下均可下發遠程控制指令。"
    }
  ],
  [
    {
      q: "車輛升級有什麽用?",
      a:
        "車輛OTA升級主要用於改善用車體驗，優化車輛功能，每次車輛OTA升級，會提示車輛升級的功能組件，每次升級的內容請以升級當時的頁面為準。"
    },

    {
      q: "車輛升級需要具備哪些條件？",
      a:
        "1.確保車輛已啟動，並處於駐車狀態。並保證車內的電池總電量大於20%，升級期間切勿不要移除電池。<br/>\
      2.確保手機的藍牙功能及無線網絡功能處於開啟狀態，並靠近車輛，保持手機與車輛處於連接狀態。"
    },
    {
      q: "車輛升級期間需要註意哪些事項？",
      a:
        "1.車輛升級期間，請不要駕駛車輛，並確保車輛處於開啟且非騎行狀態；<br/>\
      2.車輛升級期間，請勿遠離車輛，並保持車輛與手機一直處於連接狀態；<br/>\
      3.車輛升級開始後，請勿移除車輛電池；<br/>\
      4.車輛升級開始後，請勿關閉螢幕和APP，並保持手機無線網路及藍牙功能處於開啟狀態。"
    },
    {
      q: "為什麽傳輸文件總是中斷？",
      a:
        "車輛升級過程中，手機通過WiFi網路與車輛連接進行文件傳輸。在文件傳輸過程中，手機處於無網路狀態，傳輸完成後恢復手機網路。<br/>\
        部分IOS的手機用戶，會提醒用戶檢測到當前網路狀態不佳，是否斷開或切換網路，請選擇繼續使用當前網路；<br/>\
        部分Android的手機用戶，請關閉「自動選擇最近WLAN」功能，因為會自動斷開或切換網路的功能，待文件傳輸完成後重新開啟即可。"
    },
    {
      q: "升級結束了，但是不知道是否成功怎麽辦？",
      a:
        "車輛升級期間，請不要遠離車輛，並保持藍牙處於連接狀態。<br/>\
        車輛升級過程會分別在車機系統及App端呈現升級進度和升級狀態。<br/>\
        若因特殊情況，斷開了連接，可嘗試重新連接車輛。或刷新系統升級頁面，查看當前車輛版本，若均顯示「已是最新版本」則升級成功，若部分升級組件仍不是最新版本，請重新升級。"
    }
  ],
  [
    {
      q: "如何給電池充電？",
      a:
        "車輛支持多種充電補能的⽅式：<br/>\
      1.座充：<br/>\
      請將充電底座請放置在⽔平平⾯，充電前請確保充電環境⽆溫度過⾼過低、潮濕等情況；<br/>\
      將直充充電器與電源連接，再將充電底座與直充充電器連接，將電池正確放置在底座上，即可開始充電。當需要同時充兩塊電池時，請將分線器分別與充電器和兩個充電底座相連接。<br/>\
      該充電底座需要與直充充電器配合使⽤。<br/>\
      2.直充：<br/>\
      可以直接在⻋內直充，將電源插⼊充電接⼝，可以通過儀錶屏電量顯示確認電池是否充滿。<br/>\
      3.智能換電櫃：<br/>\
      部分地區覆蓋了換電櫃充電網路，可以通過開通換電服務通過換電櫃進行換電。"
    },

    {
      q: "電池使用期間有哪些註意事項？",
      a:
        "1.電池使用環境：<br/>\
        請在 -10~45℃ 環境下使⽤；<br/>\
        避免被液體浸濕；<br/>\
        避免⾦屬異物進⼊電池倉；<br/>\
        避免讓電池靠近明⽕、易燃易爆⽓體。<br/>\
      2.電池容量衰減：<br/>\
      在低溫情況下，電池可⽤容量會有不同程度的衰減，參考值為：<br/>\
      -10 ℃ 可⽤容量約為 70%；<br/>\
      0 ℃ 可⽤容量約為 85%；<br/>\
      25 ℃ 可⽤容量約為 100%；<br/>\
      3.電池安全註意事項：<br/>\
      如電池出現異常，如發熱、變形或產⽣異味，請⽴即停⽤並遠離電池，<br/>\
      聯繫售後部⻔進⾏檢修，不可私⾃拆解電池。如擅⾃拆解電池，有可能會發⽣起⽕、爆炸等安全事故，同時⾃動失去保固資格。"
    },

    {
      q: "如何延長電池的使用壽命？",
      a:
        "電池的壽命主要是由電池充電循環次數和使用存儲環境決定的，充電循環是指當電量為100%，電池完整放電一次再重新充滿記做一次充電循環。良好的使用習慣，隨用隨充，50%電量存放，溫度在0℃~25℃之間的乾燥環境存放，避免過放可以有效的延長電池的使用壽命。"
    }
  ],
  [
    {
      q: "車輛的保養方法",
      a:
        "1.定期保養的實施<br/>\
        定期保養可以有效延⻓⻋輛使⽤壽命。請⽤戶可以根據車機系統或者是App的提醒，定期對⻋輛進⾏保養。<br/>\
        未進⾏定期保養，車輛可能存在安全隱患，帶來故障或事故。定期保養過程中，如果發現車輛存在故障，請到THEMO指定門市或售後服務據點進⾏檢修。<br/>\
      2.定期保養的方法<br/>\
      隨車附帶的說明書介紹了⼀些主要的檢查項⽬，更詳細的檢修⼯作，請到THEMO指定門店、售後服務網點，或根據THEMO售後服務⼿冊要求進⾏實施。<br/>\
      在定期保養時，請註意安全並遵守下述內容∶<br/>\
      在進⾏定期保養⼯作前，請選擇地⾯平坦且空間寬闊的場所，撐起中撐後進⾏保養⼯作。<br/>\
      長時間騎⾏後的車輛電⼦部件易發熱，請勿⽴即拆解部品，否則容易發⽣破損。<br/>\
      定期保養中，如果發現車輛有異常，請及時進⾏調整，如未能⾃⾏處理異常情況，請到THEMO指定門店或售後服務據點進⾏全⾯檢查。"
    }
  ],
  [
    {
      q: "車輛不能啟動了怎麽辦？",
      a:
        "第一步：<br/>\
        檢查電源開關是否開啟，若無，請打開車輛電源開關；<br/>\
        第二步：<br/>\
        檢查車輛遙控鑰匙是否有電，可通過檢查遙控鑰匙上的指示燈是否不亮或閃爍，若無，請更換遙控鑰匙電池；<br/>\
        第三步：<br/>\
        查看車輛電池是否已安裝，若無，請裝入有充足電量的電池；若電池電量不足，請按照指示方法進行充電。<br/>\
        若通過以上方法，仍然無法啟動車輛，請聯繫指定門店或服務據點進行檢查並修理。"
    },

    {
      q: "為什麽充電後行駛里程變短？",
      a:
        "第一步：<br/>\
        檢查是否有輪胎破損或氣壓不足的情況，若發現有，請更換輪胎或給輪胎充氣；<br/>\
        第二步：<br/>\
        是否使用車輛的環境溫度過低，行駛環境溫度過低會降低電池放電效率，此為正常現象；同時，請保證充電環境溫度在5℃到55℃之間；<br/>\
        第三步：<br/>\
        檢查電池充電時間是否太短，並確定充電方法是否正確，並確認充電插頭是否正確連接；<br/>\
      *電池多次充放電後，總容量會出現壹定程度的衰減，此為正常現象；<br/>\
      若以上情況均已排查，仍無法解決，請將車輛推到指定門市或服務據點進⾏檢查並修理。"
    },

    {
      q: "充電器充電過程有發熱現象",
      a:
        "一般充電器在充電過程中溫度均會上升，屬於正常現象。<br/>\
        若充電器過熱，以至於無法用手觸碰，請立刻切斷電源停⽌充電，將充電器送到指定⻔店或售後⽹點進⾏檢查並修理。"
    },
    { q: "故障碼及處理意見", a: troubles }
  ]
];



// WEBPACK FOOTER //
// ./src/assets/js/helpMultilngual/bs_tw_questions.js